export const getRostersByClubId = (axiosInstance, clubId) => {
    const url = `/rosters/v1/clubs/${clubId}/rosters/active`;
    return axiosInstance.get(url);
};

export const getRosterPower6 = (axiosInstance, rosterId) => {
    const url = `/rosters/v1/rosters/${rosterId}/power6`;
    return axiosInstance.get(url);
};

export const addPlayerToRoster = (axiosInstance, rosterId, playerData) => {
    const url = `/rosters/v1/rosters/${rosterId}/players`;
    const payload = {
        playerId: playerData.playerId,
    };
    if (playerData.classYearId !== null && playerData.classYearId !== undefined) {
        payload.classYearId = playerData.classYearId;
    }
    if (playerData.redshirt !== null && playerData.redshirt !== undefined) {
        payload.redshirt = playerData.redshirt;
    }
    return axiosInstance.post(url, payload);
};

export const updatePlayerClassYear = (axiosInstance, rosterId, playerId, classYearId = undefined, redshirt = undefined) => {
    const url = `/rosters/v1/rosters/${rosterId}/players/${playerId}`;
    const payload = {};
    if (classYearId !== null && classYearId !== undefined) {
        payload.classYearId = classYearId;
    }
    if (redshirt !== null && redshirt !== undefined) {
        payload.redshirt = redshirt;
    }

    return axiosInstance.patch(url, payload);
};

export const removePlayerFromRoster = (axiosInstance, rosterId, playerId) => {
    const url = `/rosters/v1/rosters/${rosterId}/players/${playerId}`;
    return axiosInstance.delete(url);
};
